import { DomainCode } from '@australiangreens/ag-internal-components';

export function createBaseContactUrl(domain: DomainCode, isDev: boolean) {
  const urlDomain = domain === 'fedmps' ? 'federalmps' : domain;
  return isDev ? `contact-${urlDomain}.dev.greens.systems` : `contact-${urlDomain}.greens.org.au`;
}

export function createRocketUrlForContact(
  baseUrl: string,
  contactId?: string | number,
  cacheBustingId?: string
) {
  return cacheBustingId
    ? `https://${baseUrl}/agc/ems8${cacheBustingId}#!/contact/${contactId}`
    : `https://${baseUrl}/agc/ems8#!/contact/${contactId}`;
}

export function createInitialRocketUrl(baseUrl: string, cacheBustingId?: string) {
  return cacheBustingId
    ? `https://${baseUrl}/agc/ems8?cbi=${cacheBustingId}#!/listmanagerintegration`
    : `https://${baseUrl}/agc/ems8#!/listmanagerintegration`;
}
